import { FC, PropsWithChildren } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'

import { Utils } from '../../Utils'
import useBrand from '../../tenant/useBrand'

import Navbar from './Navbar'

export interface AppProps {
  authenticated?: boolean
}

export interface AppState {}

const AppWrapper: FC<PropsWithChildren<AppProps>> = ({ authenticated, children }) => {
  const brand = useBrand()
  return (
    <Router>
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>
        {authenticated && (
          <>
            <div className="columns is-mobile print-only" style={{ padding: 0, margin: 0 }}>
              <div className="column">
                <div>
                  {brand.vanity ? (
                    // Vanity deployments (e.g. aristotle.ai) print their headline
                    // instead of the "Aristotle | Deal Analysis" wordmark.
                    <span style={{ fontSize: 20, fontWeight: 700, lineHeight: '25px', color: '#1a1a1a' }}>
                      {brand.headline}
                    </span>
                  ) : (
                    <img
                      src={Utils.requireFromCDN('aristotle-print.svg')}
                      height="25"
                      style={{ height: 25, maxHeight: 25 }}
                    />
                  )}
                </div>
              </div>
              {!brand.vanity && (
                // Vanity deployments (e.g. aristotle.ai) drop the Pilot ITG logo.
                <div className="column is-narrow">
                  <img
                    src={Utils.requireFromCDN('itg-logo-dark.png')}
                    height="50"
                    style={{ height: 50, maxHeight: 50 }}
                  />
                </div>
              )}
            </div>

            <Navbar authenticated={authenticated} />
          </>
        )}

        {children}
      </div>
    </Router>
  )
}

export default AppWrapper
